<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("create_model_for")}}<span class="font-weight-bold">{{brandName}}</span></h4>
                <p class="text-subtitle">{{$t("model_creation_form")}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-form ref="form">
            <v-row class="mt-2">
                <v-col cols="12" md="6">
                    <v-text-field
                        outlined
                        dense
                        :label="$t('name')"
                        hide-details="auto"
                        v-model="form.name"
                        :rules="[isRequired]"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        {{$t('save')}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" @click="handleCancel">
                    <v-btn depressed block>
                        {{$t('cancel')}}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>
</template>

<script>
import service from './../../services/fleet/model';
import PAlert from './../../components/common/PAlert.vue';
import { v4 as uuid } from 'uuid';
import { isRequired } from './../../utils/validations';

export default {
    components: {
        PAlert
    },
    data() {
        return {
            form: {
                name: "",
                brand_id: null
            },
            loading: false,
            alert: {
                title: this.$t('alert_title'),
                content: "",
                callback: null,
                model: false
            },
            idempotentKey: null,
            brandName: null
        }
    },
    methods: {
        isRequired,
        handleSave() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save}
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            service.create({...this.form, idempotentKey :this.idempotentKey}).then(response => {
                console.log(response.data)
                this.$router.replace({ name: "ModelDisplay", params: { modelID: response.data.id } })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_cancel"), callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.idempotentKey = uuid();
        this.form.brand_id = this.$route.params.brandID
        this.brandName = this.$route.query.brandName
    }
}
</script>

<style>

</style>